export function SlashCircleIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='12' height='13' viewBox='0 0 12 13' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath='url(#clip0_513_22)'>
        <path
          d='M2.465 2.61496L9.535 9.68496M11 6.14996C11 8.91139 8.76142 11.15 6 11.15C3.23858 11.15 1 8.91139 1 6.14996C1 3.38854 3.23858 1.14996 6 1.14996C8.76142 1.14996 11 3.38854 11 6.14996Z'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_513_22'>
          <rect width='12' height='12' fill='white' transform='translate(0 0.149963)' />
        </clipPath>
      </defs>
    </svg>
  )
}
